import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import projectService from '../../services/project';
import type { Action } from '../../state/actions';
import {
	getProjectIdSelector,
	getProjectTypeSelector,
	projectContextSelector,
} from '../../state/context/selectors';
import type { AppState } from '../../state/types';
import { DELETE_PROJECT, deleteProjectSuccess, deleteProjectFail } from '../../state/ui/actions';
import { onProjectDeleteSuccess } from '../analytics/project-deleted/utils';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	action$.ofType(DELETE_PROJECT).mergeMap(({ meta: { analyticsEvent } }) => {
		const state = store.getState();
		const context = projectContextSelector(state);

		return Observable.fromPromise(projectService.deleteProject(context))
			.do(() =>
				onProjectDeleteSuccess(
					analyticsEvent,
					getProjectIdSelector(state),
					getProjectTypeSelector(state),
				),
			)
			.map(deleteProjectSuccess)
			.catch((error) => Observable.of(deleteProjectFail(error)));
	});
